import theme from "#next/theme";

const ModalStyleBase = {
  bgcolor: "background.paper",
  boxShadow: 24,
  overflow: "auto",
  p: 0,
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

export const DisclaimerModalStyle = {
  ...ModalStyleBase,
  p: 4,
};

export const PodcastModalStyle = {
  ...ModalStyleBase,
  width: "75vw",
  height: "75vh",
  overflow: "hidden",
  p: 4,
};

export const ExplorerModalStyle = {
  ...ModalStyleBase,
  p: 4,
  height: "75%",
  width: "75%",
  overflow: "scroll",
  "::-webkit-scrollbar": { display: "none" },
};

export const CondensedPostsModalStyle = {
  ...ModalStyleBase,
  p: 4,
  maxHeight: "75%",
  minWidth: "50%",
  maxWidth: "75%",
  overflow: "scroll",
  "::-webkit-scrollbar": { display: "none" },
};

export const FeedbackModalStyle = {
  ...ModalStyleBase,
  width: "65vw",
  minHeight: "53vh",
  p: 3,
};

export const TextSearchModalStyle = {
  ...ModalStyleBase,
  width: "90%",
  height: "90%",
};

export const FormModalStyle = {
  ...ExplorerModalStyle,
  height: "auto",
};

export const HelpModalStyle = {
  ...ModalStyleBase,
  p: 4,
  height: "75%",
};

export const TutorialModalStyle = {
  ...ModalStyleBase,
  minWidth: "75%",
  height: "75%",
};

export const MediaModalStyle = {
  ...ModalStyleBase,
  maxWidth: "75vw", //set maxwidth so image can't fill entire page
};

export const MediaSearchModalStyle = {
  ...ModalStyleBase,
  width: "90%",
  height: "90%",
};

export const QuickSearchModalStyle = {
  ...ModalStyleBase,
  p: 3,
};

export const ReportNameModalStyle = {
  ...ModalStyleBase,
  p: 3,
  pb: 1,
};

export const UserSearchModalStyle = {
  ...ModalStyleBase,
  minWidth: "25%",
  minHeight: "25%",
  maxWidth: "90%",
  maxHeight: "95%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const PostModalStyle = {
  ...UserSearchModalStyle,
  maxWidth: "75%",
  minWidth: "50%",
  maxHeight: "90%",
  flexDirection: "column",
  padding: "1em",
};

export const AlertStyle = {
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.background.paper,
};

export const ViewSearchDefinitionModalStyle = {
  ...ModalStyleBase,
  maxHeight: "90vh",
  width: "90%",
  p: 3,
};

export const PreviewModalStyle = {
  ...ModalStyleBase,
  width: "90%",
  height: "90%",
};

export const TimeRangeSelectorModalStyle = {
  ...ModalStyleBase,
  width: 400,
  border: "2px solid #000",
  p: 4,
};
